export default __webpack_public_path__ + "4afb6be90ef0874b0ee8cad3e09ef17a.png";